import React from 'react'
import { MetaTags } from '../meta-tags'

const CategoryMetaTags = ({ category }) => {
  const {
    name,
    description,
    metaTitle,
    metaDescription,
    metaTags,
    heroImage,
    sk,
    staticUrl,
    imageInfo
  } = category

  let { canonicalLink } = category
  canonicalLink = canonicalLink || `${window.location.origin}/${sk}/${staticUrl}`

  return (
    <MetaTags
      title={metaTitle ?? name}
      description={metaDescription ?? description}
      canonicalLink={canonicalLink}
      metaTags={metaTags}
      ogTags={{
        'og:title': metaTitle ?? name,
        'og:description': metaDescription ?? description,
        'og:type': 'website',
        'og:image': imageInfo?.imgUrl || heroImage
      }}
    />
  )
}

export default CategoryMetaTags
